import { Component } from '@angular/core';

@Component({
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  styleUrls: ['./politica-privacidade.component.sass']
})
export class PoliticaPrivacidadeComponent {

}
